module.exports = msal;